import { makeSubStore } from '@jarvis.oddle/core/tools/redux/store'
import { STORE_KEY } from './constants'
import * as actions from './actions'
import { initialState, reducers } from './reducers'

const initialiseState = async ({ req, store }) => {
  const menuState = store.getState()[STORE_KEY]
  if (!menuState.fetched) {
    const initialiseAction = actions.fetchMenuAction({ req })
    await store.dispatch(initialiseAction)
  }
}

export default makeSubStore(STORE_KEY, actions, reducers, initialState, initialiseState)
